// Puente hacia la instancia de Lenis para que la navegación por anclas
// use el mismo motor de scroll (evita que Lenis y el scroll nativo peleen).
let _lenis = null;
const HEADER_OFFSET = -80; // deja espacio bajo el header fijo

export const setLenis = (l) => {
  _lenis = l;
};

export const scrollToTop = () => {
  if (_lenis) _lenis.scrollTo(0, { duration: 0.8 });
  else window.scrollTo(0, 0);
};

// Scrollea a un elemento por su id (ej: "#pricing"). Devuelve true si lo encontró.
export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return false;
  if (_lenis) _lenis.scrollTo(el, { offset: HEADER_OFFSET, duration: 1.1 });
  else el.scrollIntoView({ behavior: "smooth" });
  return true;
};

// Reintenta hasta que la sección exista (por si aún no se montó al navegar).
export const scrollToIdWhenReady = (hash) => {
  let tries = 0;
  let cancelled = false;
  const tick = () => {
    if (cancelled) return;
    if (scrollToId(hash)) return;
    if (tries++ < 45) requestAnimationFrame(tick);
  };
  tick();
  return () => {
    cancelled = true;
  };
};
